import { Component, OnInit, Optional } from '@angular/core';
import { TenantService } from '../../service/tenant.service';
import { Tenant } from '../../types/tenant';
import { TenantSelectorTransform } from '../../pipes/tenant-selector-transform';

@Component({
	selector: 'ws-tenant-selector',
	templateUrl: './tenant-selector.component.html',
	styleUrls: ['./tenant-selector.component.scss'],
})
export class TenantSelectorComponent implements OnInit {
	constructor(
		@Optional() private _tenantService: TenantService,
		public tenantSelectorTransform: TenantSelectorTransform
	) {}

	public get initialized() {
		return this._tenantService.initialized;
	}

	public get activeTenantId() {
		return this._tenantService?.tenant?.tenantId.toString() || '';
	}

	public get activeTenant() {
		// @ts-ignore
		return this._tenantService?.tenant;
	}

	public set activeTenant(value: Tenant) {
		this._tenantService.selectTenant(value.tenantId.toString());
	}

	public get tenants() {
		return this._tenantService?.tenants;
	}

	ngOnInit() {}

	ngAfterViewInit() {}

	/*onSelect(index: number) {
		console.log(index);

		this._tenantService.selectTenant(index);
	}*/
}
